<template
  ><div style="padding-top:-2px;margin-top:-2px;">
    <v-label
      ><b>{{ label }}</b></v-label>
    <s-select-generic
      class="text"
      itemtext="PytDescription"
      itemvalue="PytID"
      :disabled="disabled"
      id="PytID" autocomplete full
      :value="value"
      :return-object="returnObject"
      @input="input($event)"
      :config="config"
      :text="text"
      :clearable="clearable"
      :noDefault="noDefault">
    </s-select-generic>
  </div>
</template>

<script>
import _sPaymentTerms from "@/services/Logistics/PaymentTermsService.js";
export default {
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    value: null,
    text: { type: String, default: "" },
    label: {
      type: String,
      default: "",
    },
    returnObject: {
      type: Boolean,
      default: false,
    },
    areID: {
      type: Number,
      default: 0,
    },
    noDefault: {
      type: Boolean,
      default: false,
    },    
    full: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
      areID(){
        this.config.params.AreID=this.areID;
      },
    value(value) {
    },
  },
  methods: {
    input(val) {
      this.$emit("input", val);
    },
  },
  data: () => ({
    item: 0,
    val: "",
    items: [],
    config: {},
  }),

  created() {
    this.config = {
      url: _sPaymentTerms.getURLList(),
      title: this.label,
      params: {search: "", requestID: this.$fun.getUserID() },
    };
  },
};
</script>
